import { Modal } from 'antd-v5';
import BlackButton from '../../components/BlackButton';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

interface SnAlreadyRedeemedModalProps {
    open: boolean;
    onCancel?: () => void;
    onViewMyMysteryBox?: () => void;
}

const SnAlreadyRedeemedModal: React.FC<SnAlreadyRedeemedModalProps> = ({ open, onCancel, onViewMyMysteryBox }) => {
    const { t } = useLang('SnAlreadyRedeemedModal');
    const handleViewMyMysteryBox = () => {
        onCancel?.();
        onViewMyMysteryBox?.();
    };

    return (
        <Modal className={styles.SnAlreadyRedeemedModal} open={open} onCancel={onCancel} footer={null} centered maskClosable={false}>
            <div className="modal-body">
                <p className="modal-desc">{t('title')}</p>
                <p className="modal-link-row">
                    {t('desc')}{' '}
                    <span className="modal-link" onClick={handleViewMyMysteryBox}>
                        {t('view_my_mystery_box')}
                    </span>
                    .
                </p>
            </div>
            <div className="modal-footer">
                <BlackButton type="primary" shape="round" block onClick={onCancel}>
                    {t('ok')}
                </BlackButton>
            </div>
        </Modal>
    );
};

export default SnAlreadyRedeemedModal;
